import { render, staticRenderFns } from "./ford-commercial-vehicle-display.vue?vue&type=template&id=4952f0b6&scoped=true&"
import script from "./ford-commercial-vehicle-display.vue?vue&type=script&lang=js&"
export * from "./ford-commercial-vehicle-display.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=4952f0b6&scoped=true&lang=css&"
import style1 from "./ford-commercial-vehicle-display.vue?vue&type=style&index=1&id=4952f0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952f0b6",
  null
  
)

export default component.exports